// --------------------------------------------------------
// LIBERACAO FIELD - LiberacaoField
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { Divider, TextField } from '@mui/material';
import React from 'react'
import CareLineDropdown from '../../../../../../../components/dropdown/CareLineDropdown';
import { H3 } from '../../../../../../../components/UI/generalLayout/Layout.styled'
import AddButtonField from '../AddButtonField'
import { MediumInput } from '../DetailsAttendanceRecord.styled';
import InputMask from 'react-input-mask';
import { useSelector } from 'react-redux';
import Category from '../../../../../../../models/core/careLine/Category';
import { ReactComponent as Trash } from '../../../../../../../assets/imgs/trashBin.svg';
import { removeFieldFromList } from '../../../../../../../helpers/CareLineHelperFunctions';
import useResponsiveInfo from '../../../../../../../hooks/useResponsiveInfo';
import { addValueToObject } from '../../../../../../../helpers/HelperFunctions';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// LIBERACAO FIELD INTERFACE
// --------------------------------------------------------

interface ILiberacaoField {
    liberacoes: any[];
    isViewState: boolean;
    setLiberacoes: (value: any) => void;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const LiberacaoField = ({ liberacoes, setLiberacoes, isViewState }: ILiberacaoField) => {
    // --------------------------------------------------------
    // LIBERACAO FIELD PRIVATE DECLARATIONS
    // --------------------------------------------------------
    // --------------------------------------------------------
    const { isMobile } = useResponsiveInfo();

    const allCategories: Category[] = useSelector(
        (state: any) => state.careLine.allCategories
    );

    const { currentProfile }: any = useSelector((state: any) => state.login);
    const hasPermission = currentProfile === "MED" || currentProfile === "ENF";

    const isFieldDisabled = isViewState || !hasPermission;

    // --------------------------------------------------------
    // REACT RETURN FUNCTION
    // --------------------------------------------------------
    return (
        <>
            {liberacoes.map((lib: any, index: number) => {
                return <div key={index}>
                    <div style={{ flexDirection: isMobile ? 'column' : 'row', display: 'flex', gap: isMobile ? 0 : 20 }}>
                        <div>
                            <H3>Tipo de profissional:</H3>
                            <CareLineDropdown
                                value={lib.tipoProfissional}
                                onChange={(value: any) => { addValueToObject({ tipoProfissional: value }, index, setLiberacoes) }}
                                items={allCategories}
                                containerStyle={{ width: isMobile ? '100%' : 250 }}
                                disabled={isFieldDisabled}
                                placeholder="Buscar tipo de profissional"
                            />
                        </div>
                        <div>
                            <H3>Número de sessões:</H3>
                            <InputMask
                                mask="9"
                                disabled={isFieldDisabled}
                                onKeyPress={e => { e.key === 'Enter' && e.preventDefault() }}
                                maskPlaceholder="" value={lib.numeroSessoes}
                                onChange={(event: any) => {
                                    setLiberacoes((prev: any) => {
                                        const list = [...prev];
                                        const removedElement: any[] = list.splice(index, 1);
                                        list.splice(index, 0, { ...removedElement[0], numeroSessoes: Number(event.target.value) > 0 ? event.target.value : '' })
                                        return list;
                                    })
                                }}
                            >
                                <TextField error={false} style={{ marginRight: 10, width: 80 }} />
                            </InputMask>
                        </div>
                    </div>
                    <div style={{ marginBottom: 20 }}>
                        <H3>Orientações para liberação:</H3>
                        <MediumInput
                            value={lib.orientacoes}
                            disabled={isFieldDisabled}
                            onChange={(event: any) => { addValueToObject({ orientacoes: event.target.value }, index, setLiberacoes) }}
                            placeholder='Orientações para o profissional'
                        />
                    </div>
                    {index !== 0 && !isFieldDisabled && (<div style={{ textAlign: "center", marginBottom: 8 }}>
                        <Trash onClick={() => {
                            setLiberacoes(removeFieldFromList(liberacoes, index))
                        }} style={{ cursor: 'pointer' }} />
                    </div>)}
                    <Divider />
                </div>
            })}
            {!isFieldDisabled && (<div>
                <AddButtonField
                    buttonText="Adicionar outra liberação"
                    onClickFunction={() => {
                        setLiberacoes((prev: any) => {
                            const list = [...prev];
                            list.push({ tipoProfissional: '', numeroSessoes: '', orientacoes: '' })
                            return list;
                        })
                    }}
                />
            </div>)}
        </>
    )
    // --------------------------------------------------------
}

export default LiberacaoField